<template>
  <div>
    <loading :isShow="!reload" />
    <!-- 设置产品分类 -->
    <Modal v-model="visible" title="已上架产品" @on-ok="confirmEdit" @on-cancel="cancelEdit" width="1300">
      <Transfer v-if="reload" :data="noAddedProducts" :target-keys="hasAddedProducts" filterable @on-change="handleChange" :titles="transFerTitle">
      </Transfer>
    </Modal>
  </div>
</template>

<script>
export default {
  props: [],
  components: {},
  data() {
    return {
      visible: false,
      reload: true,
      transFerTitle: [],
      hasAddedProducts: [],
      noAddedProducts: [],
      currentRow: {},
    };
  },
  methods: {
    open(row) {
      this.getProductData(row);
    },
    getProductData(row) {
      this.reload = false;
      this.currentRow = row;
      this.transFerTitle = ['全部产品', this.currentRow.name];
      this.$http({
        type: 'GET',
        url: '/buz/merchantProductThemeJoin/queryProduct',
        data: {
          themeId: row.id
        }
      }).then(res => {
        this.reload = true;
        this.visible = true;
        this.hasAddedProducts = res.data.hasAddedProducts.map(item => item.productCode);
        this.noAddedProducts = res.data.noAddedProducts.map(item => {
          let label = `<b>${item.productName}</b>`;
          if (item.themeName) {
            label += `(${item.themeName})`;
          }
          return {
            ...item,
            key: item.productCode,
            label
          };
        });
      });
    },
    cancelEditType() {
      this.clearMessage();
    },
    cancelEdit() {},
    handleChange(newTargetKeys) {
      this.hasAddedProducts = newTargetKeys;
    },
    confirmEdit() {
      this.$units.notCloseModal(this);
      this.$http({
        type: 'POST',
        url: '/buz/merchantProductThemeJoin/saveThemeProduct',
        data: {
          parentId: this.currentRow.parentId,
          themeId: this.currentRow.id,
          productCodes: this.hasAddedProducts
        }
      }).then(res => {
        this.isShowEdit === false;
        this.$Message.success('保存成功');
        this.$emit('reload');
      });
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .ivu-transfer-operation .ivu-btn {
  margin-left: 0;
}
/deep/ .ivu-transfer-list {
  height: 400px;
  width: 45% !important;
}
/deep/.ivu-transfer-list-search {
  .ivu-input-wrapper {
    z-index: 2;
  }
}
/deep/ .ivu-transfer-list-content-item {
  overflow: initial;
  white-space: initial;
  display: flex;
  &>span {
    display: inline-block;
    margin-top: -2px;
  }
}
/deep/ .ivu-input-wrapper-small .ivu-input-icon{
  height: 30px;
  line-height: 30px;
}
</style>